import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";

// @mui material components
import Card from "@mui/material/Card";

// Custom components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Encryption utilities
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";

// Background Image
import bgImage from "assets/images/bg-profile.jpeg";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const secretKey = await fetchSecretKey();
      const encryptedData = encryptBody({ username: email }, secretKey);
      console.log("Encrypted Forgot Password Payload:", encryptedData);

      const response = await axios.post("/api/forgotPassword", encryptedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      });

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
  
        if (!decryptedResponse) {
          throw new Error("Decryption failed, no data returned.");
        }
        if (decryptedResponse.success) {
        toast.success("OTP Sent Successfully!");
        setTimeout(() => {
          navigate(`/OTPVerification?email=${email}`);
        }, 100);
      } else {
        // ✅ Show backend error message such as "User not found with this email"
        const errorMessage =
          decryptedResponse?.message || "Failed to send OTP. Please try again.";
        toast.error(errorMessage);
      }
    }
  } catch (error) {
    console.error("Forgot Password Error:", error);
    toast.error(
      error.response?.data?.message ||
        "Something went wrong. Please try again later."
    );
  }
};

  return (
<BasicLayout image="/loginimage.png">
      <Card  sx={{
    borderRadius: "20px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.2)", // slightly stronger shadow
    maxWidth: 650,   
    width: "130%",    
    mx: "auto",
    mt: 10,          
    p: 5,            
  }}>
        <MDBox display="flex" justifyContent="center" mb={2}>
          <img  src={process.env.REACT_APP_IMAGE_PATH} alt="logo" style={{ height: "60px" }} />
        </MDBox>

        {/* Title */}
        <MDTypography
          variant="h5"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          color="dark"
        >
          Forgot Password
        </MDTypography>

        <MDTypography
          variant="button"
          color="text"
          textAlign="center"
          mb={3}
        >
          Enter your registered email to receive an OTP
        </MDTypography>

          <MDBox component="form" role="form" onSubmit={handleSubmit}>
          <MDBox mb={3}>
            <MDInput
              type="email"
              label="Email Address"
              fullWidth
              value={email}
              onChange={handleChange}
              required
            />
          </MDBox>

          <MDBox display="flex" alignItems="center" justifyContent="space-between">
                <MDButton
                  variant="gradient"
                  // color="info"
                  onClick={() => navigate("/")}
sx={{
      background: "#1A237E !important",  // force override gradient bg
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#1A237E !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#1A237E !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#1A237E !important",
        boxShadow: "none !important",
      },
    }}                >
                  Return to Login Page
</MDButton>

                <MDButton
  type="submit"
  variant="gradient"
  sx={{
      background: "#1A237E !important",  
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#1A237E !important", // keep same color
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#1A237E !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#1A237E !important",
        boxShadow: "none !important",
      },
    }}
>
  Send OTP
</MDButton>
              </MDBox>
            </MDBox>
      
      </Card>
    </BasicLayout>
  );
}

export default ForgotPassword;
